module.exports = __webpack_public_path__ + "circle.svg?a8dd060835127f74bb82ce973134bd58";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/circle.svg
// module id = 329
// module chunks = 0